import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Button,
  FormRow,
  ImagePickerSidebar
} from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const PartnerPopupForm = ({handleClose}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div>
      <FormRow>
        <Label>Name</Label>
        <Input className="w-full" defaultValue="Maarif Institute"/>
      </FormRow>
      <FormRow>
        <Label>Website</Label>
        <Input className="w-full" defaultValue="www.maarif.com"/>
      </FormRow>
      <FormRow last>
        <Label>Logo</Label>
        <div style={{maxWidth: isMobile ? '100%' : '150px'}}>
          <ImagePickerSidebar height="150px"/>
        </div>
      </FormRow>
      <div className="flex flex-wrap items-center">
        <Button
          style={{maxWidth: isMobile ? '100%' : '197px'}}
          thin={isMobile ? true : false}
          className="mb-5 lg:mb-0"
          onClick={handleClose}
        >
          Save
        </Button>
        <div
          className="text-center lg:text-left w-full lg:w-auto text-xs lg:text-sm text-gray-444 underline lg:ml-8 cursor-pointer"
          onClick={handleClose}
        >
          Cancel
        </div>
      </div>
    </div>
  )
}

export { PartnerPopupForm }